module.exports = __webpack_public_path__ + "static/media/bg.8e147394.png";